import { PrintType } from '@/types';

export const isEnlargeable = (printType: PrintType) =>
  printType.restrictions.scaleability === 'enlargeable';
